import styled from '@emotion/styled'
import { Typography } from '@yanolja-org/ya-com-core'

export const DiscountItem = styled.div`
  display: flex;
  align-items: flex-end;
  color: ${({ theme }) => theme.color.white};
  &.hot-deal {
    .text-wrapper {
      flex: 0 0 48px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      .text {
        flex: 0 0 28px;
        padding-right: 4px;
        margin-left: -11px;
      }
    }
  }
  &.coupon {
    margin-left: 4px;
  }
`

export const TextWrapper = styled.div<{ isHotDeal?: boolean }>`
  ${Typography('badge').bold};
  border-radius: 0.2rem;
  text-align: center;
  margin-left: ${({ isHotDeal }) => (isHotDeal ? -23 : 0)}px;
  display: flex;
  align-items: center;
`
export const HotDealText = styled.div`
  display: inline-block;
  padding-right: 0.4rem;
  line-height: 1.8rem;
`
export const CouponText = styled.div`
  display: inline-block;
  padding: 0 0.4rem;
  background-color: ${({ theme }) => theme.color.blue600};
  border: solid 0.1rem ${({ theme }) => theme.color.blue600};
  border-bottom-left-radius: 0.2rem;
  border-top-left-radius: 0.2rem;
  height: 1.8rem;
  line-height: 1.6rem;
`
export const RatioText = styled.div`
  display: inline-block;
  padding: 0 0.4rem;
  height: 1.8rem;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.color.blue600};
  border: solid 0.1rem ${({ theme }) => theme.color.blue600};
  border-bottom-right-radius: 0.2rem;
  border-top-right-radius: 0.2rem;
`

export const TicketContainer = styled.div`
  background-color: ${({ theme }) => theme.color.gray100};
  border: solid 1px #d9d9d9;
  border-radius: 2px;
  color: #2e2e2e;
  padding: 2px 4px;
`

export const ConfigBadgeWrapper = styled.div`
  margin-top: -4px;
  margin-left: -4px;
  margin-bottom: 6px;

  > * {
    float: left;
    margin-top: 0.4rem;
    margin-left: 0.4rem;
  }

  &:after {
    display: block;
    content: '';
    clear: both;
  }
`

export const BorderRectBadge = styled.div`
  padding: 0.2rem 0.5rem;
  border: 0.1rem solid ${({ theme }) => theme.color.blue100};
  border-radius: 0.2rem;
  color: ${({ theme }) => theme.color.blue600};
  ${Typography('badge').bold};
`

export const NolCareBadge = styled(BorderRectBadge)`
  border-color: ${({ theme }) => theme.color.yagreen100};
  color: ${({ theme }) => theme.color.yagreen};
`

export const BorderGrayRectBadge = styled(BorderRectBadge)`
  border-color: ${({ theme }) => theme.color.gray200};
  color: ${({ theme }) => theme.color.gray600};
`

export const FillRectBadge = styled.div`
  padding: 0.2rem 0.6rem;
  border-radius: 0.6rem;
  background-color: ${({ theme }) => theme.color.blue50};
  color: ${({ theme }) => theme.color.blue600};
  ${Typography('caption').bold};
`

export const PendingReservationBadgeLine = styled.div`
  ${Typography('badge').bold};
  padding: 0.2rem 0.4rem;
  border: 0.1rem solid ${({ theme }) => theme.color.blue100};
  border-color: ${({ theme }) => theme.color.gray900};
  background-color: ${({ theme }) => theme.color.gray900};
  color: ${({ theme }) => theme.color.white};
  border-radius: 0.2rem;
`
